const names = [
"Marie","Sophie","Camille","Julie","Emma","Chloé","Sarah","Laura",
"Manon","Léa","Clara","Inès","Lucie","Pauline","Élise","Amandine",
"Charlotte","Mathilde","Céline","Audrey","Mélanie","Caroline",
"Hélène","Margaux","Océane","Noémie","Laetitia","Aurélie",
"Nathalie","Valentine","Justine","Anaïs","Maëlle","Solène",
"Fanny","Adèle","Romane","Elodie","Capucine","Juliette",
"Alix","Estelle","Bérénice","Victoire","Louise"
];

const avatars = [];
for(let i = 0; i < 100; i++){
  avatars.push(`https://randomuser.me/api/portraits/women/${i}.jpg`);
}

const actions = [
"vient d’acheter",
"regarde actuellement",
"a ajouté",
"recommande",
"a craqué pour",
"vient de commander",
"consulte"
];

const stats = [
"🔥 Produit très demandé",
"⏳ Stock presque épuisé",
"💖 Très populaire aujourd’hui",
"👀 Plusieurs clientes regardent ce produit",
"⭐ Gros succès cette semaine"
];

const notif = document.getElementById("lux-sp");
let products = [];

async function loadProducts(){
  try {
    let allProducts = [];

    // On récupère plusieurs pages (Shopify limite à 50 par requête)
    const pagesToLoad = 4; // 4 x 50 = 200 produits max

    for(let page = 1; page <= pagesToLoad; page++){
      const res = await fetch(`/products.json?limit=50&page=${page}`);
      const data = await res.json();

      if(data.products.length === 0) break;

      allProducts = allProducts.concat(data.products);
    }

    // On transforme les produits
    products = allProducts.map(p => ({
      title: p.title,
      image: p.images.length ? p.images[0].src : '',
      link: '/products/' + p.handle
    }));

    // 🔀 Mélange aléatoire (important pour varier)
    products.sort(() => Math.random() - 0.5);

  } catch(e){
    console.log("Erreur chargement produits :", e);
  }
}

function showNotif(){

  if(products.length === 0) return;

  const name = names[Math.floor(Math.random() * names.length)];
  const avatar = avatars[Math.floor(Math.random() * avatars.length)];
  const product = products[Math.floor(Math.random() * products.length)];
  const action = actions[Math.floor(Math.random() * actions.length)];
  const stat = stats[Math.floor(Math.random() * stats.length)];

  const message = Math.random() > 0.5
    ? `${name} ${action} cet article`
    : stat;

  notif.querySelector(".lux-sp-avatar img").src = avatar;
  notif.querySelector(".lux-sp-text").innerText = message;
  notif.querySelector(".lux-sp-product").src = product.image;
  notif.querySelector(".lux-sp-product-link").href = product.link;

  notif.classList.add("show");

  setTimeout(() => {
    notif.classList.remove("show");
  }, 4000);
}

loadProducts().then(() => {
  setInterval(showNotif, 30000);
});